import isEmpty from "lodash/isEmpty";

const parseStructuredNotes = (notes) => {
    if (isEmpty(notes)) return [];

    return notes.map((note) => {
        const parts = String(note || "")
            .split("|")
            .map((item) => item.trim())
            .filter(Boolean);

        if (parts.length === 0) {
            return { universityName: "-", comments: [] };
        }

        if (parts.length === 1) {
            return { universityName: "-", comments: [parts[0]] };
        }

        return {
            universityName: parts[parts.length - 1],
            comments: parts.slice(0, -1),
        };
    });
};

export const deserializeReport = (data) => {
    const attendedUniversities = isEmpty(data.universities)
        ? []
        : data.universities
              .filter((item) => item && item.attendance)
              .map((item) => ({
                  universityName: item.university_name || "-",
                  attendance: Boolean(item.attendance),
                  crmId: item.crm_id || item.university_crm_id || "",
                  universityCrmId: item.university_crm_id || item.crm_id || "",
                  university_crm_id: item.university_crm_id || item.crm_id || "",
                  universityCode: item.university_code || "",
              }));

    return {
        name: data.name,
        registrantCode: data.unique_code,
        email: data.email,
        type: data.user_type,
        intake: data.intake || "-",
        notes: isEmpty(data.notes) ? "-" : data.notes.join(", "),
        formattedNotes: parseStructuredNotes(data.notes),
        program: isEmpty(data.target_programs) ? "-" : data.target_programs.join(", "),
        degreeType: isEmpty(data.level_and_type) ? "-" : data.level_and_type.join(", "),
        attendedUniversities,
        university: isEmpty(data.universities)
            ? "-"
            : data.universities.reduce((names, item) => {
                  if (item.attendance)
                      names = names ? `${names}, ${item.university_name}` : item.university_name;

                  return names;
              }, "") || "-",
    };
};
